module.exports = __webpack_public_path__ + "img/info_history.efd0128.png";